import { gql, useMutation } from '@apollo/client';

import { EventInteraction } from '@/graphql-types/globalTypes';

import {
  UseTrackEventInteraction_SaveEventInteraction,
  UseTrackEventInteraction_SaveEventInteractionVariables,
} from './graphql-types/UseTrackEventInteraction_SaveEventInteraction';

const SAVE_EVENT_INTERACTION = gql`
  mutation UseTrackEventInteraction_SaveEventInteraction(
    $input: SaveEventInteractionInput!
  ) {
    saveEventInteraction(input: $input) {
      _
    }
  }
`;

export const useTrackEventInteraction = (options: {
  eventMetadata:
    | { simpleEventId: string }
    | { conferenceSessionId: string }
    | { conferenceBoothId: string }
}): { trackEventInteraction: (interaction: EventInteraction) => void } => {
  const [saveEventInteraction] = useMutation<
    UseTrackEventInteraction_SaveEventInteraction,
    UseTrackEventInteraction_SaveEventInteractionVariables
  >(SAVE_EVENT_INTERACTION);

  return {
    trackEventInteraction: (interaction) => {
      saveEventInteraction({
        variables: {
          input: { eventMetadata: options.eventMetadata, interaction },
        },
      });
    },
  };
};
